import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LcPoolSummary } from '../hooks/useLiquidityCachePools';

interface PoolStatsProps {
  pool: LcPoolSummary;
}

export function PoolStats({ pool }: PoolStatsProps) {
  const price =
    BigInt(pool.reserveA) > 0n && BigInt(pool.reserveB) > 0n
      ? (Number(pool.reserveB) / Number(pool.reserveA)).toFixed(6)
      : 'N/A';

  const inversePrice =
    BigInt(pool.reserveA) > 0n && BigInt(pool.reserveB) > 0n
      ? (Number(pool.reserveA) / Number(pool.reserveB)).toFixed(6)
      : 'N/A';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Cache Statistics</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <StatItem label={`Reserve ${pool.tokenA.symbol}`} value={pool.reserveA} />
          <StatItem label={`Reserve ${pool.tokenB.symbol}`} value={pool.reserveB} />
          <StatItem
            label={`Price (${pool.tokenA.symbol})`}
            value={`${price} ${pool.tokenB.symbol}`}
          />
          <StatItem
            label={`Price (${pool.tokenB.symbol})`}
            value={`${inversePrice} ${pool.tokenA.symbol}`}
          />
          <StatItem label="Total LP Shares" value={pool.totalLpShares} />
          <StatItem label="Fee" value={`${(pool.feeBps / 100).toFixed(2)}%`} />
          <StatItem label="Max Trade" value={`${pool.maxTradePct}% of reserve`} />
          <StatItem label="Status" value={pool.status} />
        </div>
      </CardContent>
    </Card>
  );
}

function StatItem({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-muted-foreground">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
}
